module.exports = __webpack_public_path__ + "static/media/listing.e9d4a945.jpg";